import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { IconDeviceMobile } from '@tabler/icons-react';
import { getSupabase } from '../lib/supabase';
import { useMingo } from '../context/MingoContext';

const LS_KEY = 'mingo_contact_banner_dismissed';

export default function ContactSetupBanner() {
  const navigate = useNavigate();
  const { t } = useMingo();
  const [show, setShow] = useState(false);

  useEffect(() => {
    // 이미 닫은 적 있으면 표시 안 함
    if (localStorage.getItem(LS_KEY)) return;

    const sb = getSupabase();
    if (!sb) return;

    void sb.auth.getUser().then(async ({ data: { user } }) => {
      if (!user) return;
      const { data } = await sb
        .from('users')
        .select('contact_kakao, contact_whatsapp, contact_zalo, contact_phone')
        .eq('auth_id', user.id)
        .maybeSingle();
      if (!data) return;
      const hasAny = data.contact_kakao || data.contact_whatsapp || data.contact_zalo || data.contact_phone;
      if (!hasAny) setShow(true);
    });
  }, []);

  function dismiss() {
    localStorage.setItem(LS_KEY, '1');
    setShow(false);
  }

  if (!show) return null;

  return (
    <div
      style={{
        margin: '12px 16px',
        padding: '14px 16px',
        background: 'linear-gradient(135deg, #ede9fe, #fce7f3)',
        borderRadius: 12,
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        boxShadow: '0 2px 8px rgba(124,58,237,0.1)',
      }}
    >
      <div style={{ fontSize: 28, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <IconDeviceMobile size={28} stroke={1.75} aria-hidden />
      </div>
      <div style={{ flex: 1 }}>
        <p style={{ margin: 0, fontSize: 13, fontWeight: 700, color: '#4c1d95' }}>{t('contactSetup.title')}</p>
        <p style={{ margin: '2px 0 0', fontSize: 12, color: '#6d28d9' }}>
          {t('contactSetup.desc')}
        </p>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        <button
          type="button"
          className="mingo-btn mingo-btn--primary"
          style={{ fontSize: 12, padding: '6px 12px', whiteSpace: 'nowrap' }}
          onClick={() => navigate('/settings/account')}
        >
          {t('contactSetup.registerBtn')}
        </button>
        <button
          type="button"
          style={{
            fontSize: 11,
            color: '#9ca3af',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: 0,
          }}
          onClick={dismiss}
        >
          {t('contactSetup.later')}
        </button>
      </div>
    </div>
  );
}
